import styled from 'styled-components/macro';
import { Link } from 'react-router-dom';

const PreviewContainer = styled(Link)`
  position: relative;
  display: block;
  flex: 0 0 80px;
  height: 80px;
`;

export default PreviewContainer;
